/**
 *  Date    : 2017/6/23
 *  Author  : CastileMan
 *  Declare : 分享设置
 */

import React from 'react';

import { fromJS, is } from 'immutable';
import uuid from '@wtdc/shortid';

import * as jwx from '@/utils/Jweixin';
import Utils from '@/utils/utils';
import cookie from '@/utils/cookie';
import analysisengineapi from '@/api/analysisengine';
// import { LinkUtils } from 'CommonComponentFolder/Link';

import { removeConfig, setConfig } from './WxShareConfigUtils';
import { addTrack, TRACK_TYPE } from '@/business/spider/track';

export let wxReady = false;
class ShareConfig extends React.Component {
  static defaultProps = {
    config: {},                             // 通用分享设置 { title: '', desc: '', imgUrl: '', link: '' }
    friendConfig: {},                       // 好友分享专用设置
    circleConfig: {},                       // 朋友圈分享专用设置
    topSize: 10                             // 分享的优先级，默认为10，最外层默认分享为0
  };

  constructor(props) {
    super(props);
    this.isAndroid = Utils.browser().android;
    this.id = uuid();
    this.cookie = cookie.get();
    this.unmounted = false;
    this.commonShareQuery = this.getCommonShareQuery();
  }

  getCommonShareQuery() {
    return {
      source_type: 'WECHAT_SHARE'
    };
  }

  setShareConfig(
    config = this.props.config,
    friendConfig = this.props.friendConfig,
    circleConfig = this.props.circleConfig
  ) {
    if(wxReady) {
      let defaultShareLink = Utils.filterQuery(window.location.href, QUERY_FILTER_LIST);
      friendConfig = Utils.searchAssign(friendConfig);
      circleConfig = Utils.searchAssign(circleConfig);
      let friend = Object.assign({ link: defaultShareLink }, config, friendConfig);
      let circle = Object.assign({ link: defaultShareLink }, config, circleConfig);

      // 分享出去的链接带上参数adviserId（若cookie中存在）
      // 增加分享出去来源参数 source_type：WECHAT_SHARE https://docs.qq.com/sheet/BBZ4d01Uwrxe0icP8H2Bhj301uKtQg25TwzV3?opendocxfrom=tim#x72446
      const padQuery = this.getCommonShareQuery();

      friend.link = Utils.padQuery(Utils.filterQuery(friend.link, QUERY_FILTER_LIST), padQuery);
      circle.link = Utils.padQuery(Utils.filterQuery(circle.link, QUERY_FILTER_LIST), padQuery);
      let success = () => {
        config.success && config.success();
        this.shareTrack(friend, circle);
      };
      setConfig({
        id: this.id,
        topSize: this.props.topSize
      }, {
        title: friend.title || '',
        desc: friend.desc || '',
        link: friend.link, // LinkUtils.getLinkUrl(friend.link || defaultShareLink),
        imgUrl: Utils.getOriginFile(friend.imgUrl || ''),
        success
      }, {
        title: circle.title || '',
        link: circle.link, // LinkUtils.getLinkUrl(circle.link || defaultShareLink),
        imgUrl: Utils.getOriginFile(circle.imgUrl || ''),
        success
      });
    }
  }

  /**
   * 进行分享的记录埋点
   */
  shareTrack(friend, circle) {
    const { serviceInfo = {}} = this.props;
    let params = {
      browseId: serviceInfo.appId || serviceInfo.productId,
      browseName: friend.title || circle.title,
      typeClass: serviceInfo.appId ? 'APP' : 'PRODUCT'
    };
    params.browseId && analysisengineapi.shareTrack(params);
    // 通用分享埋点
    addTrack({
      type: TRACK_TYPE.SHARE,
      spm: '4013',
      subSpm: serviceInfo.appId || serviceInfo.productId
    });
  }

  init() {
    jwx.init();
    wx.ready(() => {
      wxReady = true;
      this.setShareConfig(...arguments);
    });
  }

  componentWillMount() {
    this.init();
  }

  componentWillReceiveProps(nextProps) {
    if(this.unmounted) return;
    if(!is(fromJS(this.props.config), fromJS(nextProps.config))
      || !is(fromJS(this.props.friendConfig), fromJS(nextProps.friendConfig))
      || !is(fromJS(this.props.circleConfig), fromJS(nextProps.circleConfig))) {
      this.setShareConfig(nextProps.config, nextProps.friendConfig, nextProps.circleConfig);
    }
  }

  componentDidUpdate(prevProps) {
    if(this.unmounted) return;
    if(this.props.pathname !== prevProps.pathname) {
      let func = this.isAndroid ? this.init : this.setShareConfig;
      func(this.props.config, this.props.friendConfig, this.props.circleConfig);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;

    removeConfig(this.id);
  }

  render() {
    return null;
  }
}

export default ShareConfig;

const QUERY_FILTER_LIST = ['wechatUserId', 'userCode', 'userId', 'openid', 'code', 'traceId'];
